<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="font-family:Arial;"><strong>List of Tables</strong></h1>
<table style="margin:auto; font-weight:bold;">
<colgroup>
<col width="20%"/>
<col width="50%"/>
</colgroup>
<thead>
<tr class="header">
<td align="right" style="border:0px solid white; padding-top:5px;"><strong>Table 1:<br/></strong></td>
<td align="left" style="border:0px solid white;"><strong> Articulation Disorders Versus Phonological </strong></td>
</tr>
</thead>
<tbody>
<tr class="odd">
<td align="right" style="border:0px solid white;"><strong>Table 2:</strong></td>
<td align="left" style="border:0px solid white;">Unusual Error Patterns</td>
</tr>
<tr class="even">
<td align="right" style="border:0px solid white;"><strong>Table 3:</strong></td>
<td align="left" style="border:0px solid white;">Methods Used to Collect a Speech Sample</td>
</tr>
<tr>
<td align="right" style="border:0px solid white; padding-top:5px;"><strong>Table 4:<br/><br/></strong></td>
<td align="left" style="border:0px solid white;">Summary of Commonly Administered Tests of<br/>
Phonology</td></tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9bec2050